<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2018-->
<div id="nexleader-wrapper">
  <div class="content animate-panel">
    <div class="row">
      <div class="col-md-12">
        <div class="hpanel m-n">
          <div class="panel-heading">
            <div class="panel-tools">
              <a (click)="openCreateLicenseDiscount()"
                ><i class="fa fa-plus"></i>&nbsp;&nbsp;Create new Discount
                Code</a
              >
            </div>
            <span>License Discount Codes</span>
          </div>
          <div class="panel-body">
            <p>
              Group admins enter these in the IPSAT Store when buying licenses.
              A code sets the price of each license; it never raises a price
              that is already lower.
            </p>
            <div class="table-responsive" *ngIf="licenseDiscounts.length > 0">
              <table class="table">
                <thead>
                  <th>Code</th>
                  <th>Faith-Based Price</th>
                  <th>Values-Based Price</th>
                  <th>Last Day Valid</th>
                  <th>Actions</th>
                </thead>
                <tbody>
                  <tr *ngFor="let licenseDiscount of licenseDiscounts">
                    <td>{{ licenseDiscount.name }}</td>
                    <td>{{ licenseDiscount.faithBasedPrice | number : '1.2-2' }}</td>
                    <td>{{ licenseDiscount.valuesBasedPrice | number : '1.2-2' }}</td>
                    <td>
                      {{ licenseDiscount.expiresAt ? (licenseDiscount.expiresAt | date : 'mediumDate') : 'Never expires' }}
                    </td>
                    <td><a (click)="remove(licenseDiscount)">Delete</a></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p *ngIf="licenseDiscounts.length < 1">
              There are no discounts to show.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
